<!--
 * @Author: CaoYang
 * @Date: 2026-06-26 09:40:33
 * @LastEditTime: 2026-08-07 19:53:35
 * @FilePath: /麒麟论坛/qlgc-web/src/App.vue
 * @Description: 
 * 
 * Copyright (c) 2026 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div id="app">
	<Header v-if="!$route.meta.isProductCase"/>
	<div :class="[$route.meta.isFull?'':'container']">
		<router-view></router-view>
	</div>
	<Footer v-if="!$route.meta.isProductCase"/>
  </div>
</template>

<script>
import Header from './components/header'
import Footer from './components/footer'
export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  mounted() {
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>

	#app{
		position: relative;
		width: 100%;
		max-width: 100%;
		overflow-x: hidden;
		box-sizing: border-box;
		.container{
			// margin: 0 auto;
			padding-top: 88px;
			min-height: 500px;
		}
		font[size="4"] {
      font-size: 11px;
		}
		font[size="6"] {
      font-size: 20px;
		}
		font[size="7"] {
      font-size: 30px;
		}

	}
</style>
